export default __webpack_public_path__ + "static/media/IMG_4566-min.34e6a30b.JPG";